export enum ModalType {
  General,
  AttributeAssignment,
}
